import axios from 'axios'

async function getAllDistributors (query) {
  query = query || {}
  query.sortDesc = true
  query.limitless = true
  return axios.get('/admin/distributors', { params: query })
}

async function getSingleDistributor (id) {
  const distributor = await axios.get(`/admin/distributors/${id}`)
  return (distributor.data.data)
}

async function addDistributor (distributor) {
  const res = await axios.post('/admin/distributors', distributor)
  return (res.data.data)
}

async function updateDistributor (id, distributor) {
  const newDistributor = await axios.put(`/admin/distributors/${id}`, distributor)
  return (newDistributor.data.data)
}

async function deleteDistributor (id) {
  const d = await axios.delete(`/admin/distributors/${id}`)
  return d.data.data
}

async function getMaxOrder (id) {
  const d = await axios.get(`/admin/distributors/${id}/maxorder`)
  return d.data.data
}

async function getActivations (id) {
  try {
    const res = await axios.get(`/admin/distributors/${id}/activated`)
    return res.data.data
  } catch (err) {
    console.log(err)
  }
}

export default {
  getAllDistributors,
  addDistributor,
  getSingleDistributor,
  updateDistributor,
  deleteDistributor,
  getMaxOrder,
  getActivations
}



// WEBPACK FOOTER //
// ./src/api/distributors.js